import api, { transformCursorResponse, transformRequest, transformResponse } from "services/api";

export const communicationTasksApi = api
  .enhanceEndpoints({ addTagTypes: ["CommunicationTasks", "CommunicationHistories"] })
  .injectEndpoints({
    endpoints: (build) => ({
      getCommunicationTasksList: build.query({
        query: (payload) => ({
          url: `/api/v1/core/communication/tasks/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformCursorResponse(response),
        providesTags: () => [{ type: "CommunicationTasks", id: "LIST" }],
      }),
      bulkCancelCommunicationTasks: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/communication/tasks/bulk-cancel/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        invalidatesTags: () => [{ type: "CommunicationTasks", id: "LIST" }],
      }),
      fetchVoiceConfig: build.query({
        query: () => `/api/v1/agency/communication/voice/config/`,
        transformResponse: (response) => transformResponse(response),
      }),
      generateWebrtcToken: build.mutation({
        query: () => ({
          url: `/api/v1/agency/communication/voice/webrtc-token/`,
          method: "POST",
        }),
        transformResponse: (response) => transformResponse(response),
      }),
      createVoiceTask: build.mutation({
        query: (payload) => ({
          url: `/api/v1/agency/communication/voice/create-task/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
      }),
      getCommunicationHistoriesList: build.query({
        query: (payload) => ({
          url: `/api/v1/core/communication/histories/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformCursorResponse(response),
        providesTags: () => [{ type: "CommunicationHistories", id: "LIST" }],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useGetCommunicationTasksListQuery,
  useGetCommunicationHistoriesListQuery,
  useBulkCancelCommunicationTasksMutation,
  useFetchVoiceConfigQuery,
  useGenerateWebrtcTokenMutation,
  useCreateVoiceTaskMutation,
} = communicationTasksApi;
